import { render, staticRenderFns } from "./Risk.vue?vue&type=template&id=9955d6ae&scoped=true&"
import script from "./Risk.vue?vue&type=script&lang=tsx&"
export * from "./Risk.vue?vue&type=script&lang=tsx&"
import style0 from "./Risk.vue?vue&type=style&index=0&id=9955d6ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9955d6ae",
  null
  
)

export default component.exports